import axios from 'axios'

export default function (app) {
  app.config.globalProperties.axios = axios
  app.config.globalProperties.$http = axios
  app.provide('axios', axios)
}
